import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "folder-meta-bar" }
const _hoisted_2 = { class: "duration-badge" }
const _hoisted_3 = { class: "library-download-progress" }
const _hoisted_4 = { class: "library-download-actions" }
const _hoisted_5 = {
  key: 0,
  class: "library-download-current-file ion-text-center"
}
const _hoisted_6 = {
  key: 0,
  class: "library-download-file-index"
}
const _hoisted_7 = { class: "music-list-scroll" }
const _hoisted_8 = { class: "track-number" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "track-info" }
const _hoisted_11 = { class: "track-name" }
const _hoisted_12 = { class: "track-duration" }
const _hoisted_13 = { class: "track-actions" }
const _hoisted_14 = { class: "play-button-wrapper" }
const _hoisted_15 = {
  key: 0,
  class: "ion-padding ion-text-center empty-tracks-hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_progress_bar = _resolveComponent("ion-progress-bar")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { class: "music-library-folder-header" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, {
                    "default-href": "/music-library",
                    text: ""
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.folderTitle), 1)
                ]),
                _: 1
              }),
              (_ctx.showOfflineActions && !_ctx.downloadProgressBar.downloading)
                ? (_openBlock(), _createBlock(_component_ion_buttons, {
                    key: 0,
                    slot: "end"
                  }, {
                    default: _withCtx(() => [
                      (!_ctx.folderOffline)
                        ? (_openBlock(), _createBlock(_component_ion_button, {
                            key: 0,
                            fill: "clear",
                            onClick: _ctx.saveOffline,
                            "aria-label": "Сохранить офлайн"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                icon: _ctx.cloudDownloadOutline,
                                slot: "icon-only"
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createVNode(_component_ion_icon, {
                              icon: _ctx.cloudDone,
                              class: "toolbar-offline-done",
                              "aria-hidden": "true"
                            }, null, 8, ["icon"]),
                            _createVNode(_component_ion_button, {
                              fill: "clear",
                              class: "toolbar-remove-offline",
                              onClick: _ctx.confirmRemoveFolderOffline,
                              "aria-label": "Удалить из офлайна"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  icon: _ctx.trashOutline,
                                  slot: "icon-only"
                                }, null, 8, ["icon"])
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ], 64))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        class: "main-background-dark music-library-folder-content",
        fullscreen: true
      }, {
        default: _withCtx(() => [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "release-safe-area" }, null, -1)),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_ion_icon, { icon: _ctx.timeOutline }, null, 8, ["icon"]),
              _createElementVNode("span", null, _toDisplayString(_ctx.mediaUtils.formatTime(_ctx.mediaUtils.getTotalPlaylistDuration(_ctx.musicList))), 1)
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_ion_button, {
                fill: "outline",
                class: "library-download-cancel",
                onClick: _ctx.stopLibraryMusicDownload
              }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode(" Отмена ", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_ion_text, { class: "library-download-meta ion-text-center" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.downloadProgressBar.downloaded) + " Мб", 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_text, { class: "library-download-hint ion-text-center" }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("Не закрывайте окно до завершения загрузки", -1)
                ]))]),
                _: 1
              })
            ]),
            (_ctx.downloadProgressBar.currentFileLabel)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                  (_ctx.libraryDownloadFilePosition)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.libraryDownloadFilePosition), 1))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.downloadProgressBar.currentFileLabel), 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_ion_progress_bar, {
              value: _ctx.libraryDownloadProgressValue,
              type: "determinate",
              class: "library-download-progress-bar"
            }, null, 8, ["value"])
          ], 512), [
            [_vShow, _ctx.downloadProgressBar.downloading]
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_ion_list, {
              class: "bg-transparent music-library-track-list",
              lines: "none"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.musicList, (audioTrack, idx) => {
                  return (_openBlock(), _createBlock(_component_ion_item, {
                    key: audioTrack.id,
                    class: _normalizeClass(["music-item music-library-track-item", { playing: _ctx.isTrackRowActive(idx) }]),
                    onClick: ($event: any) => (_ctx.selectTrack(idx))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        (!_ctx.isTrackRowActive(idx))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(idx + 1), 1))
                          : (_openBlock(), _createBlock(_component_ion_icon, {
                              key: 1,
                              icon: _ctx.playerBar.playing ? _ctx.pause : _ctx.play,
                              class: "playing-icon"
                            }, null, 8, ["icon"]))
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.mediaUtils.getTrackName(audioTrack)), 1),
                        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.mediaUtils.formatTime(audioTrack.duration)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        (_ctx.showOfflineActions)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (!audioTrack.isOffline)
                                ? (_openBlock(), _createBlock(_component_ion_button, {
                                    key: 0,
                                    fill: "clear",
                                    class: "track-offline-btn",
                                    disabled: _ctx.downloadProgressBar.downloading,
                                    "aria-label": "Сохранить трек офлайн",
                                    onClick: _withModifiers(($event: any) => (_ctx.saveTrackOffline(audioTrack)), ["stop"])
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        icon: _ctx.cloudDownloadOutline,
                                        slot: "icon-only"
                                      }, null, 8, ["icon"])
                                    ]),
                                    _: 1
                                  }, 8, ["disabled", "onClick"]))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createVNode(_component_ion_icon, {
                                      icon: _ctx.cloudDone,
                                      class: "offline-icon"
                                    }, null, 8, ["icon"]),
                                    _createVNode(_component_ion_button, {
                                      fill: "clear",
                                      class: "track-offline-btn track-remove-offline-btn",
                                      disabled: _ctx.downloadProgressBar.downloading,
                                      "aria-label": "Удалить трек из офлайна",
                                      onClick: _withModifiers(($event: any) => (_ctx.confirmRemoveTrackOffline(audioTrack)), ["stop"])
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, {
                                          icon: _ctx.trashOutline,
                                          slot: "icon-only"
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    }, 8, ["disabled", "onClick"])
                                  ], 64))
                            ], 64))
                          : (audioTrack.isOffline)
                            ? (_openBlock(), _createBlock(_component_ion_icon, {
                                key: 1,
                                icon: _ctx.cloudDone,
                                class: "offline-icon"
                              }, null, 8, ["icon"]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.isTrackRowActive(idx) && _ctx.playerBar.playing ? _ctx.pause : _ctx.play,
                            class: "play-icon"
                          }, null, 8, ["icon"])
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["class", "onClick"]))
                }), 128))
              ]),
              _: 1
            }),
            (!_ctx.musicList.length && !_ctx.tracksLoading)
              ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.emptyTracksHint), 1))
              : _createCommentVNode("", true),
            (_ctx.tracksLoading)
              ? (_openBlock(), _createBlock(_component_ion_spinner, {
                  key: 1,
                  class: "ion-margin tracks-spinner",
                  name: "crescent"
                }))
              : _createCommentVNode("", true),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "fake-footer" }, null, -1))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}